import React, {useEffect, useState} from 'react';
import "./style/style.css";
import {Typography, message, Space, Row, Col, Card, Divider, Spin, Pagination} from 'antd';
import {Modal} from 'antd';
import smmileApi from "services/smmile";


const loadingOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    zIndex: 1000, // Ensure it covers other content
};


const createList = (data) => {
    return (
        <ul>
            {Object.keys(data).map(key => (
                <li key={key}>
                    <strong>{key}:</strong> {data[key]}
                </li>
            ))}
        </ul>
    );
};


const SMMILEOverview = () => {
    const [annotations, setAnnotations] = useState([]);
    const [statistics, setStatistics] = useState(null);
    const [groupedAnnotations, setGroupedAnnotations] = useState({});
    const [backendError, setBackendError] = useState({});
    const [isBackendLoading, setIsBackendLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);


    useEffect(() => {
        setBackendError({})
        setIsBackendLoading(false)
        fetchRows(0)
    }, []);

    const fetchRows = async (offset) => {
        setIsBackendLoading(true)
        const ret = await smmileApi.fetchRows(offset);
        setIsBackendLoading(false)
        if ("error" in ret) {
            setBackendError(ret)
            return
        }
        console.log(ret)
        let response = ret["response"]
        let statistics = ret["statistics"]

        setAnnotations(response)
        console.log(response)

        setStatistics(statistics)
        // Group data by problem_id
        const groupedData = response.reduce((acc, item) => {
            acc[item.row.problem_id] = [...(acc[item.row.problem_id] || []), item];
            return acc;
        }, {});
        setGroupedAnnotations(groupedData)
        console.log(response)
    }


    const handlePageChange = (page) => {
        setCurrentPage(page);
    };


    const showConfirm = (parquetPath) => {
        Modal.confirm({
            title: 'Confirm Removal',
            content: 'Are you sure you want to remove this example?',
            okText: 'Remove',
            cancelText: 'Cancel',
            onOk: async () => {
                const response = await smmileApi.removeAnnotations(parquetPath);
                if ("deleted" in response) {
                    if (response["deleted"]) {
                        message.success("Sample deleted");
                    } else {
                        message.error("Cannot delete sample, something is wrong");
                    }
                } else {
                    message.error("Cannot delete sample, something is wrong");
                }
            },
        });
    };


    const renderProblemGroup = (key, problemGroup) => {
        const sortedGroup = problemGroup.sort((a, b) => a.row.order - b.row.order);

        return (
            <div className="site-card-wrapper" key={problemGroup[0].row.problem_id}>
                <Divider orientation="left">Author: {sortedGroup[0].row.author} -
                    Specialty: {sortedGroup[0].row.speciality}
                    - <a onClick={() => showConfirm(sortedGroup[0].row.parquet_path)}>[remove]</a>
                    - <a href={`/smmile/add?key=${key}&username=${sortedGroup[0].row.author}`}>[edit]</a>
                    - problem id: {sortedGroup[0].row.problem_id}
                </Divider>
                <Row justify="space-evenly">
                    {sortedGroup.map((item, index) => (
                        <Col span={2} key={item.row.order}>
                            <Card
                                title={`${index === sortedGroup.length - 1 ? 'Final Problem' : `Example ${item.row.order}`}`}
                                hoverable
                                bordered={true}
                                cover={<img src={item.row.image_url} alt={`Example ${item.row.order}`}
                                            style={{maxWidth: "100%", maxHeight: 150}}/>}
                                style={{width: 240, height: 400}}

                            >

                                <div
                                    style={{fontSize: 16, fontWeight: 500, paddingBottom: 10}}>{item.row.question}</div>
                                <div style={{color: "grey"}}>
                                    Answer: {item.row.answer}<br/>
                                </div>
                                <p></p>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </div>
        );
    };
    const pageSize = 20;
    const keys = Object.keys(groupedAnnotations);
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    const currentKeys = keys.slice(startIndex, endIndex);

    const currentAnnotations = currentKeys.reduce((acc, key) => {
        acc[key] = groupedAnnotations[key];
        return acc;
    }, {});
    console.log(groupedAnnotations)
    console.log(currentAnnotations)
    return (
        <>
            {isBackendLoading && (
                <div style={loadingOverlayStyle}>
                    <Spin tip="Loading..."/>
                </div>
            )}
            {backendError && Object.keys(backendError).length > 0 && backendError.constructor === Object &&
                <div>
                    <pre>{JSON.stringify(backendError, null, 2)}</pre>
                </div>
            }
            <Space direction="vertical">
                {statistics &&
                    <div>
                        <h1>Dataset Statistics</h1>

                        <h2>General Information</h2>
                        <p><strong>Number of unique problems:</strong> {statistics.unique_problems}</p>
                        <p><strong>Total number of rows:</strong> {statistics.total_rows}</p>

                        <h2>Number of Unique Problems per Specialty</h2>
                        <div>{createList(statistics.specialty_problem_count)}</div>

                        <h2>Number of Unique Problems per Author</h2>
                        <div>{createList(statistics.author_problem_count)}</div>
                    </div>
                }
                <Pagination
                    current={currentPage}
                    total={Object.entries(groupedAnnotations).length}
                    showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                    pageSize={pageSize}
                    onChange={handlePageChange}
                />
                <Typography>
                    <>
                        {Object.entries(currentAnnotations).map(([key, group]) => renderProblemGroup(key, group))}
                    </>
                </Typography>
            </Space>
        </>
    );
};

export default SMMILEOverview;
